import config from "@~/envConfig";
import { EVENTS } from "./basketEvents";
import {
  AddToBasketRequestBasketItemChildItem,
  BasketRequestResponse,
} from "@~/queries/add-to-basket-client/types.gen";

export type ATBEvent = {
  res?: BasketRequestResponse;
  variantId?: string;
  skuId?: string;
  quantity?: number;
};

const RequestFailedError = {
  errors: [
    {
      message:
        "There was a problem with your request, please check your network connection and try again. If the problem persists please try again later.",
      code: "REQUEST_FAILED",
    },
  ],
};

export const CLIENT_ID = "web-plp-scaffold-ui";

// Returns JWT
export const authenticate = async () => {
  if (typeof window !== "undefined") {
    // @ts-ignore - can't figure out why the definition in auth0.d.ts isn't being picked up
    return window.auth0?.getTokenIfAuthenticated();
  }

  return "";
};

export async function addToBasketRequest({
  variantId,
  quantity = 1,
  clientId = CLIENT_ID,
  childItems = undefined,
}: {
  variantId: string;
  quantity?: number;
  clientId?: string;
  childItems?: Array<AddToBasketRequestBasketItemChildItem>;
}): Promise<BasketRequestResponse> {
  const authToken = await authenticate();

  return fetch(`${config.basketBFFBaseUrl}/basket/items/${variantId}`, {
    method: "POST",
    body: JSON.stringify({
      variantId,
      quantity,
      childItems,
    }),
    credentials: "include",
    headers: {
      "x-api-client-id": clientId,
      "Content-Type": "application/json",
      ...(authToken && { Authorisation: `Bearer ${authToken}` }),
    },
  }).then(
    (res) => {
      if (res.ok) {
        return res.json();
      }
      if (res.status !== 404) {
        return res.json().then(
          (resJson) => Promise.reject(resJson),
          () => Promise.reject(RequestFailedError),
        );
      }
      return Promise.reject(RequestFailedError);
    },
    () => Promise.reject(RequestFailedError),
  );
}

export const updateHeaderBasketCount = () => {
  const updateBasketEvent = new CustomEvent(
    EVENTS.JL_EVENTS_BASKET_QUANTITY_UPDATED,
  );
  window.dispatchEvent(updateBasketEvent);
};

export const triggerSuccessEvent = (data: ATBEvent) => {
  const addToBasketSuccessEvent = new CustomEvent(
    EVENTS.JL_EVENTS_ADD_TO_BASKET_SUCCESS,
    {
      detail: data,
    },
  );
  window.dispatchEvent(addToBasketSuccessEvent);
};

export const triggerErrorEvent = (data: ATBEvent) => {
  const addToBasketErrorEvent = new CustomEvent(
    EVENTS.JL_EVENTS_ADD_TO_BASKET_ERROR,
    {
      detail: data,
    },
  );
  window.dispatchEvent(addToBasketErrorEvent);
};

export const triggerClickEvent = (data: ATBEvent) => {
  const addToBasketClickEvent = new CustomEvent(
    EVENTS.JL_EVENTS_ADD_TO_BASKET_CLICK,
    {
      detail: data,
    },
  );
  window.dispatchEvent(addToBasketClickEvent);
};
